import React from "react";
import styled from "styled-components";
import { Grid } from "semantic-ui-react";

export interface MainGridProps {
  columns: number;
  fitted?: boolean;
  className?: string;
  list?: boolean;
}

// / Only global style
const FlexGrid = styled(Grid)<{ fitted: 0 | 1 }>(({ fitted }) => ({
  "&&&": {
    display: "flex",
    justifyContent: "center",
    textAlign: "center",
    margin: "0",
    marginBottom: fitted ? "0em" : "1em",
    width: "100%",
    ".column": {
      textAlign: "initial",
    },
  },
}));

const MainGrid: React.FC<MainGridProps> = ({
  className,
  children,
  columns,
  list,
  fitted,
}) => (
  <FlexGrid
    columns={columns}
    stackable={!list}
    className={className}
    fitted={fitted ? 1 : 0}
  >
    {children}
  </FlexGrid>
);

export default MainGrid;
